const INITIAL_STATE = {
    cupom: {},
    cupons: [],
    loading: false,
    processing: false,
}

export default function CupomDeDesconto(state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'CUPOM_LOADING' :
            return { ...state, loading: action.payload };
        case 'CUPOM_PROCESSING' :
            return { ...state, processing: action.payload };
        case 'CUPONS_FETCHED':
            return { ...state, cupons: action.payload };
        case 'CUPOM_FETCHED':
            return { ...state, cupom: action.payload };
        default:
            return state
    }
}